import { ModuleWithProviders, NgModule } from '@angular/core';
import { GtmService } from '@df/module-gtm/gtm.service';
import { GtmTrackSelectItemDirective } from '@df/module-gtm/track/select-item/gtm-track-select-item.directive';
import { GtmTrackViewItemListDirective } from '@df/module-gtm/track/view-item-list/gtm-track-view-item-list.directive';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NModuleGtm } from './df-module-gtm.config';
import { providers } from './gtm.providers';

/**
 * This GTM module is for tracking events in Google Tag Manager.
 * It use Google Analytics 4 data layer.
 */
@NgModule({
    imports: [GtmTrackSelectItemDirective, GtmTrackViewItemListDirective],
    exports: [GtmTrackSelectItemDirective, GtmTrackViewItemListDirective]
})
export class DfModuleGtmModule {
    static forRoot(config?: DeepPartial<NModuleGtm.IModuleOptions>): ModuleWithProviders<DfModuleGtmModule> {
        return {
            ngModule: DfModuleGtmModule,
            providers: providers(config)
        };
    }

    constructor(gtmService: GtmService) {
        gtmService.appInitialize();
    }
}
